<mf-auto-complete
  [label]="label"
  [endpointSuggest]="endpointSuggest"
  [ngModel]="value?.name ?? ''"
  [filters]="filters"
  [orderBy]="orderBy"
  [readOnly]="readOnly"
  [wrappedNgControl]="ngControl"
  (selectedItemChange)="selectedItemChange($event)"></mf-auto-complete>
